const globalFeatures = {
  CHECKOUT_RESOURCE: 'global_checkout_resource',
  USE_SELECTED_LANGUAGE: 'global_use_selected_language',
  CHECKOUT_PRELOAD_ASSETS: 'global_checkout_preload_assets',
  CHECKOUT_INITIALIZE_ENDPOINT: 'global_checkout_initialize_endpoint',
  GLOBAL_CHECKOUT_BLAZE: 'global_checkout_blaze',
  SCHEMA_ORG_GENERATION: 'global_schema_org_generation',
  BUTTON_DEMO: 'button_demo',
  RETURNING_CUSTOMERS: 'global_checkout_returning_customers',
  INJECT_CUSTOM_JS: 'global_inject_client_javascript',
  ENABLE_CARTV2: 'global_shopify_js_cart_v2',
  DISPLAY_PDP_SHIPPING: 'global_display_pdp_shipping',
  GLOBAL_CHECKOUT_EXPERIMENT_TEST: 'global_feature_for_experiment',
};

export default globalFeatures;



// WEBPACK FOOTER //
// ./static/js/v0/constants/features.js